import {Requirement} from './Requirement'
export class Requirements {

  constructor(
    readonly form: string,
    readonly requirements: Requirement[],    
  ) {
  }
}